// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_iobject.js
// module id = 79
// module chunks = 0 2 3 6 7 8 10 11 12 13 14 16 17 19 21 22 23 25 26 27 28 29 31 32 33 34 35 36 37 38 40 41 43 44 45 47 48 49 51 52